import React, { useContext, useEffect, useState } from "react";

import { UserContext } from "../../../context";
import WatchPlaylistPage from "../../playlists/WatchPlaylistPage";
import ProjectComponentFrame from "./ProjectComponentFrame";

export default function ProjectPlaylistComponent(props) {
    const { currentUserData } = useContext(UserContext);
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (currentUserData && props.component) {
            setIsEditing(props.isEditing);
        }
    }, [currentUserData, props.component, props.isEditing]);

    return (
        <ProjectComponentFrame
            component={props.component}
            isEditing={isEditing}
            label="Playlist"
            onDelete={() => props.delete(props.component)}
            onMoveUp={() => props.moveUp(props.component)}
            onMoveDown={() => props.moveDown(props.component)}
        >
            <WatchPlaylistPage
                playlistKey={props.component.linkKey}
                projectCreatedBy={props.projectCreatedBy}
            />
        </ProjectComponentFrame>
    );
}
